var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      staticClass: "my-1 mx-2",
      attrs: { rounded: "", color: _vm.value ? "primary" : "lightgrey" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm._v("\n  " + _vm._s(_vm.label) + "\n  "),
      _c("v-chip", { staticClass: "ml-2", attrs: { small: "" } }, [
        _vm._v("\n    " + _vm._s(_vm.number) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }